// Match on a path boundary so `/12` does not match `/123`.
export const isWithinPath = (pathname, basePath) =>
  pathname === basePath || pathname.startsWith(`${basePath}/`);

// Angular expects the path relative to `basePath`, while svelte-routing expects
// the full path.
export const deriveMountedPath = (pathname, search, basePath) => {
  if (!isWithinPath(pathname, basePath)) return null;

  const query = search || "";
  return {
    full: pathname + query,
    relative: (pathname.slice(basePath.length) || "/") + query,
  };
};
